export default __webpack_public_path__ + "static/media/ic_svg_alerta.952db890.svg";